const googleMapsKey =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "AIzaSyAkztZWkCtaXwNAjm_uVd8Jvh6ILgoEuM8";

declare global {
  interface Window {
    google?: unknown;
    __pulsGoogleMapsPromise?: Promise<void>;
  }
}

export function loadGoogleMaps(): Promise<void> {
  if (window.google) {
    return Promise.resolve();
  }

  if (window.__pulsGoogleMapsPromise) {
    return window.__pulsGoogleMapsPromise;
  }

  window.__pulsGoogleMapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Google Maps failed to load"));
    document.head.appendChild(script);
  });

  return window.__pulsGoogleMapsPromise;
}
